export const borrowSealRouting = [
	{
    path: "/sealManage/borrowSeal/list",
    name: "borrowSeal-list",
    meta: { title: "借印管理" },
    component: () =>
      import(/* webpackChunkName: "borrowSeal-list" */ "@/views/seal-management/borrowSeal/list/index.vue"),
  },
	{
    path: "/sealManage/borrowSeal/create",
    name: "borrowSeal-create",
    meta: { title: "新建借印申请", comName:"SealManageBorrowSealFormCreate" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "borrowSeal-create" */ "@/views/seal-management/borrowSeal/form-create/index.vue"),
  },
	{
    path: "/sealManage/borrowSeal/edit/:id",
    name: "borrowSeal-edit",
    meta: { title: "编辑借印申请", comName:"SealManageBorrowSealFormCreate" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "borrowSeal-edit" */ "@/views/seal-management/borrowSeal/form-create/index.vue"),
  },
	{
    path: "/sealManage/borrowSeal/detail/:id",
    name: "borrowSeal-detail",
    meta: { title: "借印详情" },
		hidden:true,
    component: () =>
      import(/* webpackChunkName: "borrowSeal-detail" */ "@/views/seal-management/borrowSeal/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/sealManage/borrowSeal/flowPrint/:id",
    name: "sealManage-borrowSeal-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/seal-management/borrowSeal/flow-print/index.vue"
      ),
  },
]